module.exports = __webpack_public_path__ + "img/scroll12.63407f4d.png";